import type { ISEOItems } from './props';

export enum ArticleStatus {
  Setup = 0,
  Published = 1,
  Expired = 2,
}
export interface IBlogProps {
  totalArticleCount: number;
  title: string;
  slug: string;
  articlePreviews: IArticle[];
  recentPosts: ArticlePreview[];
  seo?: ISEOItems;
  markup?: string;
}

export interface ISharedBlogProps extends IBlogProps {
  seo?: ISEOItems;
}

export interface IArticle {
  _id: number | string;
  ArticleName: string;
  Slug: string;
  PermaLink?: string;
  Summary: string;
  Heading: string;
  Markup: string;
  PublishDate: string;
  UpdateDate: string;
  FeaturedImage: {
    ImageAltText?: string;
    ImageURL: string;
    ImageMetadata?: Record<string, string>;
  };
  ArticleTags: string[];
  Blog?: string;
  BlogSlug?: string;
}

export type ArticlePreview = Omit<IArticle, 'Markup'>;
